<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-50"
      :bodyStyle="{ paddingTop: '12px' }"
    >
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>Activity Form</h6>
          </a-col>
        </a-row>
      </template>
      <!-- form -->
      <a-row>
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Date of activity <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-date-picker
            format="YYYY-MM-DD"
            v-model="formActivity.date_of_activity"
          />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Activity Name <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formActivity.name_of_activity" />
        </a-col>
      </a-row>
      <!-- <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Type of activity <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-select
            class="ant-select"
            show-search
            placeholder="select..."
            option-filter-prop="children"
            v-model="formActivity.type_of_activity"
            style="width: 70%"
          >
            <a-select-option
              v-for="(item, index) in optionTypeAc"
              :key="index"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row> -->
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Organized by <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formActivity.organized_by" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Location <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-textarea
            placeholder=""
            :rows="5"
            v-model="formActivity.location"
          />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Activity expenses <span class="text-danger"></span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-radio-group v-model="formActivity.activity_expenses">
                <a-radio-button :value="true">Yes</a-radio-button>
                <a-radio-button :value="false">No</a-radio-button>
              </a-radio-group>
        </a-col>
      </a-row>
      <a-card style="box-shadow:none" v-if="formActivity.activity_expenses">
        <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            <b>Budget (Activity Expense)</b>
          </p>
        </a-col>
      </a-row>
        <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Actual Expense Details <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-textarea
            placeholder=""
            :rows="5"
            v-model="formActivity.actual_expense_detail"
          />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Grand Total <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formActivity.grand_total" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Income <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formActivity.income" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Profit <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formActivity.profit" />
        </a-col>
      </a-row>
      </a-card>

      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            No. of Participants <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input type="number" v-model="formActivity.no_of_participants" />
        </a-col>
      </a-row>

      <div class="mb-10 text-center">
        <a-row type="flex" align="middle" style="margin-top: 20px">
          <a-col :span="12" :offset="6" align="center">
            <a-button
              block
              type="primary"
              :disabled="formActivity.name_of_activity == ''"
              @click="visibleAddForm = !visibleAddForm"
            >
            Add activity
            </a-button>
          </a-col>
        </a-row>
      </div>
    </a-card>
    <!-- modla -->
    <a-modal
      v-model="visibleAddForm"
      title="Confirm add new activity ?"
      on-ok="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="visibleAddForm = !visibleAddForm">
          Close
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingBtn"
          @click="onSubmitForm"
        >
          Submit
        </a-button>
      </template>
      <p>
        You have reviewed the correctness of the information before saving ?
      </p>
    </a-modal>
  </div>
</template>

<script>
const formActivity = {
  name_of_activity: "",
  date_of_activity: "",
  organized_by: "",
  location: "",
  haveExpense:"false",
  profit: 0,
  income: 0,
  grand_total: 0,
  actual_expense_detail: "",
  activity_expenses:false,
  no_of_participants:0
  // donation: 0,
  // type_of_activity: "",
  // type_of_activity_other: "",
  // actual_expense: 0,
  // advance_budget: 0,
  // budget: 0,
};

export default {
  data() {
    return {
      formActivity: Object.assign({}, formActivity),
      itemSaveId: [],
      enggaItems: [],
      optionTypeAc: [],
      visibleAddForm: false,
      loadingBtn: false,
    };
  },
  mounted() {
    this.getOptionType();
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/activity",
        })
        .catch((err) => { });
    },
    addItem() {
      this.enggaItems.push({
        typex: "",
        namex: "",
        amount: "",
        id: Date.now(),
      });
    },
    removeItem(item) {
      // //console.log(item);
      let index = this.enggaItems.indexOf(item);
      if (index !== -1) {
        this.enggaItems.splice(index, 1);
      }
    },
    async getOptionType() {
      this.optionTypeAc = [];
      try {
        const res = await this.$http.get(`/student_affair/type-of-activity/`);
        if (res.status === 200) {
          this.optionTypeAc = res.data.map((item) => {
            return {
              value: item.id,
              text: `${item.name_eng}`,
            };
          });
        }
      } catch (error) {}
    },
    async onSaveItem() {
      this.itemSaveId = [];
      for (let aI = 0; aI < this.enggaItems.length; aI++) {
        const listData = this.enggaItems[aI];
        const sendData = new FormData();
        sendData.append("by_type", listData.typex);
        sendData.append("item_detail", listData.namex);
        sendData.append("amount", listData.amount);
        try {
          const response = await this.$http.post(
            "/student_affair/donation-item/",
            sendData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (response.status === 201) {
            this.itemSaveId.push(response.data.id);
          } else {
            throw { response };
          }
        } catch (error) {
          this.errorSubmit = error;
          this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /student_affair/donation-item/`,
        });
        }
      }
    },
    async onSubmitForm() {
      this.loadingBtn = true;
      try {
        this.formActivity.date_of_activity = this.moment(this.formActivity.date_of_activity).format("YYYY-MM-DD")
        const response = await this.$http.post(
          "/student_affair/alumni-activity/",
          this.formActivity,
        );
        if (response.status === 201) {
          this.formActivity = Object.assign({}, formActivity);
          this.itemSaveId = [];
          this.enggaItems = [];
          this.$router
            .push({
              path: "/activity",
            })
            .catch((err) => {});
          this.loadingBtn = false;
        } else {
          throw { response };
        }
      } catch (error) {
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /student_affair/alumni-activity/`,
        });
      }
    },
  },
};
</script>